<template>
  <div class="mobile-main">
    <!-- Loading -->
    <div class="loading-mask" v-if="isLoading">
      <div class="loading-message">ページを読み込んでいます...</div>
      <VueLoading type="spin" color="#eee" :size="loadingSize" />
    </div>

    <!-- Title -->
    <v-card class="d-flex align-center" height="34" color="#44485C" tile>
      <v-img
        class="mx-2"
        contain
        width="20"
        height="20"
        max-height="20"
        max-width="20"
        :src="require('@/assets/MobileLogo.svg')"
        v-if="false"
      ></v-img>
      <h4 class="white--text text-no-wrap ml-2">
        {{ appTitle }}
      </h4>
      <v-btn icon @click="displayMenu" class="ml-auto">
        <v-icon color="white">mdi-menu</v-icon>
      </v-btn>
    </v-card>

    <!-- Menu -->
    <MapMenu v-if="isShowMenu" @close="isShowMenu = false" />

    <!-- Details -->
    <v-dialog
      v-model="isShowMapDetail"
      width="95dwh"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-toolbar dense flat color="primary" height="34">
          <v-card class="body-2 white--text" color="primary" flat>
            {{ mapDetail.title }}
          </v-card>
          <v-spacer />
          <v-btn dark icon @click="closeMapDetail">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0" style="max-height: 90dvh">
          <template v-if="mapDetail.contents === 'stage-detail'">
            <StageDetail />
          </template>
          <template v-if="mapDetail.contents === 'rainfall-detail'">
            <RainDetail />
          </template>
          <template v-if="mapDetail.contents === 'camera-detail'">
            <CameraDetail />
          </template>
          <template v-if="mapDetail.contents === 'live-camera-detail'">
            <LiveCameraDetail />
          </template>
          <template v-if="mapDetail.contents === 'wind-detail'">
            <WindDetail />
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Map -->
    <div :class="selectedRisk.slider ? 'ninety-height' : 'full-height'">
      <mobile-base-map>
        <template v-slot:bottomleft>
          <v-btn
            rounded
            small
            style="pointer-events: painted"
            @click="displayMenu()"
          >
            Menu
          </v-btn>
        </template>
      </mobile-base-map>
    </div>
    <!-- Slider -->
    <div v-if="selectedRisk.slider" class="ten-height">
      <MobileTimeSeriesControl />
    </div>
  </div>
</template>

<script>
import { Risk } from "../enums/Risk";
import MobileBaseMap from "../components/base-map/MobileBaseMap";
import MobileTimeSeriesControl from "../components/base-map/mobileLayers/MobileTimeSeriesControl";
import MapMenu from "../components/base-map/mobileLayers/MapMenu";
import StageDetail from "../components/base-map/details/StageDetail";
import RainDetail from "../components/base-map/details/RainDetail";
import CameraDetail from "../components/base-map/details/CameraDetail";
import LiveCameraDetail from "../components/base-map/details/LiveCameraDetail";
import { VueLoading } from "vue-loading-template";
import WindDetail from "../components/base-map/details/WindDetail";

export default {
  name: "Mobile",
  components: {
    VueLoading,
    MobileTimeSeriesControl,
    MobileBaseMap,
    MapMenu,
    StageDetail,
    RainDetail,
    CameraDetail,
    LiveCameraDetail,
    WindDetail
  },
  data() {
    return {
      isShowMenu: false,
      loadingSize: { width: "80px", height: "80px" }
    };
  },
  created() {
    this.$store.commit("SET_SELECTED_RISK", Risk.RAIN);
  },
  mounted() {
    this.$nextTick(() => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
  computed: {
    isShowMapDetail() {
      return this.$store.getters.isShowMapDetail;
    },
    mapDetail() {
      return this.$store.getters.mapDetail;
    },
    selectedRisk() {
      return this.$store.getters.selectedRisk;
    },
    isLoading() {
      return this.$store.getters.isLoading;
    },
    appTitle() {
      return "RisKma田村市";
    }
  },
  methods: {
    closeMapDetail() {
      const dialog = {
        isShowing: false
      };
      this.$store.commit("SET_MAP_DETAIL", dialog);
    },
    displayMenu() {
      this.isShowMenu = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-main {
  position: fixed;
  padding: 0;
  margin: 0;
  width: 100vw;
  height: 100%;
}
.full-height {
  width: 100%;
  position: relative;
  height: calc(var(--vh, 1vh) * 100 - 34px) !important;
}
.ninety-height {
  width: 100%;
  position: relative;
  height: calc(var(--vh, 1vh) * 100 - 34px - 80px) !important;
}
.ten-height {
  height: 80px !important;
}
.loading-mask {
  z-index: 2000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(88, 88, 88, 0.5);
  text-align: center;
}
.loading-message {
  margin-top: 40%;
  font-size: 0.9em;
  color: rgb(30, 30, 30);
}
.basetime-control {
  top: 55px;
  right: 10px;
  position: absolute;
  pointer-events: none;
}
</style>
